export const STUDENT_FEATURE_KEY = 'admin-student';
